// extracted by mini-css-extract-plugin
export var dateLabel = "_3w-0";
export var dateLabelError = "_3w-1";
export var fullWidth = "_3w-2";
export var smaller = "_3w-3";